export interface TipoVeiculoModel {
    name?: string;
    descricao?: string;
  }
  
  export const tiposVeliculoList: TipoVeiculoModel[] = [
    { name: "LEVE", descricao: "Leve" },
    { name: "UTILITARIO", descricao: "Utilitário" },
    { name: "PESADO", descricao: "Pesado" },
    { name: "ULTRA_PESADO", descricao: "Extra Pesado" },
    { name: "MUNCK", descricao: "Munck" }
  ];